"use strict";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
gsap.registerPlugin(EaselPlugin, ScrollTrigger);
import SimpleBar from "simplebar";

window.addEventListener("DOMContentLoaded", () => {});

/******************
 * PROJECT SYSTEM
 ******************/
// PC
const leadAnimePc = document.querySelectorAll(".js-lead-anime-pc");
leadAnimePc.forEach((item) => {
  ScrollTrigger.create({
    trigger: item,
    start: "top 75%",
    once: true,
    onEnter: () => {
      borderAnime();
      window.setTimeout(iconAnime, 600);
      window.setTimeout(listAnime, 600);
    },
  });
});
function borderAnime() {
  const border = document.querySelectorAll(".js-border");
  for (let i = 0; i < border.length; i++) {
    (function (i) {
      setTimeout(function () {
        border[i].classList.add("is-active");
      }, i * 600);
    })(i);
  }
}
function iconAnime() {
  const icon = document.querySelectorAll(".js-icon");
  for (let i = 0; i < icon.length; i++) {
    (function (i) {
      setTimeout(function () {
        icon[i].classList.add("is-active");
      }, i * 300);
    })(i);
  }
}
function listAnime() {
  const list = document.querySelectorAll(".js-list");
  for (let i = 0; i < list.length; i++) {
    (function (i) {
      setTimeout(function () {
        list[i].classList.add("is-active");
      }, i * 300);
    })(i);
  }
}

// SP

const leadAnimeSp = document.querySelectorAll(".js-lead-anime-sp");
leadAnimeSp.forEach((item) => {
  ScrollTrigger.create({
    trigger: item,
    start: "top 50%",
    once: true,
    onEnter: () => {
      borderAnimeSp();
      window.setTimeout(listLeftAnimeSp, 400);
      window.setTimeout(listRightAnimeSp, 700);
    },
  });
});
function borderAnimeSp() {
  const borderSp = document.querySelectorAll(".js-border-sp");
  for (let i = 0; i < borderSp.length; i++) {
    borderSp[i].classList.add("is-active");
  }
}
function listLeftAnimeSp() {
  const itemSp = document.querySelectorAll(".js-item-left-sp");
  for (let i = 0; i < itemSp.length; i++) {
    (function (i) {
      setTimeout(function () {
        itemSp[i].classList.add("is-active");
      }, i * 300);
    })(i);
  }
}
function listRightAnimeSp() {
  const itemSp = document.querySelectorAll(".js-item-right-sp");
  for (let i = 0; i < itemSp.length; i++) {
    (function (i) {
      setTimeout(function () {
        itemSp[i].classList.add("is-active");
      }, i * 300);
    })(i);
  }
}

/******************
 * JOB DESCRIPTION
 ******************/
const descriptionItem = document.querySelectorAll(".js-description-item");
descriptionItem.forEach((item) => {
  ScrollTrigger.create({
    trigger: item,
    start: "top 75%",
    once: true,
    onEnter: () => {
      item.classList.add("is-active");
    },
  });
});
